(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var section = document.currentScript.closest('.product-section') || document.querySelector('.product-section');
    if (!section) return;

    var variantsEl = document.getElementById('ProductVariants');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var optionSelectors = section.querySelectorAll('[data-option-selector]');
    var variantIdInput = section.querySelector('[data-variant-id]');
    var addToCartBtn = section.querySelector('[data-add-to-cart]');
    var buttonText = section.querySelector('[data-button-text]');
    var buttonPrice = section.querySelector('[data-button-price]');

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    }

    function findMatchingVariant() {
      var selected = Array.prototype.map.call(optionSelectors, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === undefined || opt === selected[i]; });
      });
    }

    function updateForVariant() {
      var variant = findMatchingVariant();
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (addToCartBtn) addToCartBtn.disabled = !variant.available;
      if (buttonText && buttonPrice) {
        buttonPrice.textContent = formatMoney(variant.price);
        var addLabel = addToCartBtn.getAttribute('data-label-add');
        var soldOutLabel = addToCartBtn.getAttribute('data-label-sold-out');
        var label = variant.available ? addLabel : soldOutLabel;
        buttonText.innerHTML = variant.available ? (label + ' — <span data-button-price>' + formatMoney(variant.price) + '</span>') : label;
      }
      var priceWrap = section.querySelector('[data-product-price]');
      if (priceWrap) {
        priceWrap.innerHTML = variant.compare_at_price && variant.compare_at_price > variant.price
          ? '<span class="product-info__price--sale">' + formatMoney(variant.price) + '</span><span class="product-info__price--compare">' + formatMoney(variant.compare_at_price) + '</span>'
          : '<span>' + formatMoney(variant.price) + '</span>';
      }
      if (variant.featured_media) {
        var slide = section.querySelector('[data-gallery-slide="' + (variant.featured_media.position - 1) + '"]');
        var thumb = section.querySelector('[data-gallery-thumb="' + (variant.featured_media.position - 1) + '"]');
        if (slide) activateSlide(slide, thumb);
      }
    }

    optionSelectors.forEach(function (select) {
      select.addEventListener('change', updateForVariant);
    });

    /* gallery */
    var slides = section.querySelectorAll('[data-gallery-slide]');
    var thumbs = section.querySelectorAll('[data-gallery-thumb]');

    function activateSlide(slide, thumb) {
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      slide.classList.add('is-active');
      if (thumb) thumb.classList.add('is-active');
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-gallery-thumb');
        var slide = section.querySelector('[data-gallery-slide="' + index + '"]');
        if (slide) activateSlide(slide, thumb);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
